module.exports = __webpack_public_path__ + "static/img/logo.d358b84a.svg";